import { z } from 'zod'
import { bzOptional } from '../common-schemas'

export const EquipmentManufacturerSchema = bzOptional(z.string())
export type EquipmentManufacturer = z.infer<typeof EquipmentManufacturerSchema>

export const KNOWN_MANUFACTURERS: string[] = [
  'ACiQ',
  'ADP',
  'AirEase',
  'AirQuest',
  'Amana',
  'American Standard',
  'APCO',
  'Apollo',
  'Aprilaire',
  'Bosch',
  'Bradford White',
  'Bryant',
  'Carrier',
  'Champion',
  'Coleman',
  'Daikin',
  'Ducane',
  'Ecobee',
  'Frigidaire',
  'Goettl',
  'Goodman',
  'Healthy Climate',
  'Honeywell',
  'Lennox',
  'Mitsubishi',
  'Ptak',
  'Rheem',
  'Trane',
  'WaterFurnace',
  'Weil McLain',
  'York',
]

export const EquipmentModelNumberSchema = z.string()
export type EquipmentModelNumber = z.infer<typeof EquipmentModelNumberSchema>

export const EquipmentSerialNumberSchema = z.string()
export type EquipmentSerialNumber = z.infer<typeof EquipmentSerialNumberSchema>
